import {
  APPLICATION_FETCHED
} from 'utils/constants'

export default (state = {}, action) => {
  switch (action.type) {
    case APPLICATION_FETCHED: {
      const { application: newApp } = action.data;
      const oldApp = state[newApp.number];
      return { ...state, [newApp.number]: { ...oldApp, ...newApp } };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/applications.js